var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0006 8.00005C18.0006 8.19896 17.9216 8.38973 17.7809 8.53038C17.6403 8.67103 17.4495 8.75005 17.2506 8.75005H2.5609L8.03122 14.2194C8.1009 14.2891 8.15617 14.3718 8.19389 14.4629C8.2316 14.5539 8.25101 14.6515 8.25101 14.7501C8.25101 14.8486 8.2316 14.9462 8.19389 15.0372C8.15617 15.1283 8.1009 15.211 8.03122 15.2807C7.96153 15.3504 7.87881 15.4056 7.78776 15.4433C7.69672 15.4811 7.59914 15.5005 7.50059 15.5005C7.40204 15.5005 7.30446 15.4811 7.21342 15.4433C7.12237 15.4056 7.03965 15.3504 6.96996 15.2807L0.219965 8.53068C0.150233 8.46102 0.0949134 8.3783 0.0571702 8.28726C0.019427 8.19621 0 8.09861 0 8.00005C0 7.90149 0.019427 7.80389 0.0571702 7.71285C0.0949134 7.6218 0.150233 7.53908 0.219965 7.46943L6.96996 0.719426C7.1107 0.578695 7.30157 0.499634 7.50059 0.499634C7.69961 0.499634 7.89048 0.578695 8.03122 0.719426C8.17195 0.860156 8.25101 1.05103 8.25101 1.25005C8.25101 1.44907 8.17195 1.63995 8.03122 1.78068L2.5609 7.25005H17.2506C17.4495 7.25005 17.6403 7.32907 17.7809 7.46972C17.9216 7.61037 18.0006 7.80114 18.0006 8.00005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/LeftArrow.3aa4ae3d68e5e7415f0d2f1f355c6747.svg";
export { ForwardRef as ReactComponent };